'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const StyleOptions=[
'success',
'warning',
'info',
'alert',
'secondary',
'error'];let


NotificationService=function(_BaseService){_inherits(NotificationService,_BaseService);
function NotificationService($rootScope){_classCallCheck(this,NotificationService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$rootScope=$rootScope;
_this._$rootScope.alerts=[];
_this._$rootScope.closeAlert=_this._closeAlert.bind(_this);return _this;
}NotificationService.prototype.

_closeAlert=function _closeAlert(index){
this._$rootScope.alerts.splice(index,1);
};NotificationService.prototype.

displayNotification=function displayNotification(message){let alertType=arguments.length>1&&arguments[1]!==void 0?arguments[1]:'info';
if(!_(StyleOptions).includes(alertType)){
throw new Error(`Alert type "${alertType}" is not a valid option.`);
}

if(alertType==='error'){
alertType='alert';
}

this._$rootScope.alerts.push({message:message,type:alertType});
};return NotificationService}(BaseService);


module.exports=NotificationService;
//# sourceMappingURL=notificationService.js.map
